import GoogleMap from 'components/GoogleMap/index.js'
import Parking from './Parking.js'

export default class Parkings {
  constructor() {
    this.el = document.getElementById('parkings-map')
    this.parkings = []

    document.querySelectorAll('.js-parking-button').forEach((element) => {
      const instance = new Parking(element)
      this.parkings.push(instance)
    })

    if (this.el) {
      new GoogleMap(this.el, this.parkings)
    }
  }
}
